<template>  <footer class="app-footer">
    <div class="footer-content">
      <div class="footer-left">
        <span>RouteBox</span>
      </div>
      <div class="footer-center">
        <p>© 2025 RouteBox. All rights reserved.</p>
      </div>
      <div class="footer-right">
        <p class="version">v1.0.0</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
.app-footer {
  background-color: #2c3e50;
  color: white;
  padding: 0.4rem 1rem;
  height: 32px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-content {  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.7);
}

.footer-left {
  display: flex;
  align-items: center;
}

.footer-logo {
  height: 18px;
  margin-right: 6px;
}

.footer-left span {
  font-family: 'Sansation', sans-serif;
  letter-spacing: 0.5px;
  font-weight: bold;
}

.footer-center {
  text-align: center;
}

.footer-right {
  text-align: right;
}

p {
  margin: 0;
}

.version {
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.75rem;
}
</style>
